import { render, staticRenderFns } from "./upload-presentation-modal.vue?vue&type=template&id=c3e4e1e6&scoped=true"
import script from "./upload-presentation-modal.vue?vue&type=script&lang=js"
export * from "./upload-presentation-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-presentation-modal.vue?vue&type=style&index=0&id=c3e4e1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e4e1e6",
  null
  
)

export default component.exports